// extracted by mini-css-extract-plugin
module.exports = {"chart":"workspaceChart_chart__JOPVA","toolTipText":"workspaceChart_toolTipText__54qyI"};